import { render, staticRenderFns } from "./UserEditGeneral.vue?vue&type=template&id=17478d2a"
import script from "./UserEditGeneral.vue?vue&type=script&lang=js"
export * from "./UserEditGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports